import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CustomModal } from '../../components/customModal';
import { Text, View } from 'react-native';
import { useCssStyle } from '../../customHook/getCssStyle';
import { useTranslation } from 'react-i18next';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { ImageComp } from '../../components/Image/Image';
import { KEY_ICON, SUCCESS_CHECK } from '../../assets';
import CustomPressable from '../../components/customPressable/customPressable';
import { setIsAutoLoggedIn } from '../../Redux/Reducers/appConfigReducer';
import InfoPopupModal from '../../components/infoPopupModal';

const AutoLoginSuccessModal = () => {

  const getStyles = useCssStyle();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { loggedInRoomNumber, doorKeyType } = useSelector((state) => state.appConfigSlice);
  const { currentGuestDetails } = useSelector(state => state.guestDetailsSlice);

  const handleCloseModal = () => {
    dispatch(setIsAutoLoggedIn(false));
  };

  return (

    <InfoPopupModal
      title={t('login.auto_login_success_heading').replace("#GUESTNAME", currentGuestDetails?.guestName)}
      children={<View id='autoLoginCardBody' style={getStyles(['autoLoginCardBody'])}>
        <View id='autoLoginCardBodyTextContainer' style={getStyles(['autoLoginCardBodyTextContainer'])}>
          <Text id='autoLoginCardBodyLoginText' style={getStyles(['autoLoginCardBodyLoginText'])}>
            {t('login.auto_login_success_message').replace('#ROOMNUMBER', loggedInRoomNumber || "")}
          </Text>

          <Text id='autoLoginGenericDoorkeyText' style={getStyles(['autoLoginGenericDoorkeyText'])}>
            {doorKeyType && doorKeyType != "" ? (
              <>
                {t('check_in.digital_key_msg1')}
                <ImageComp
                  source={KEY_ICON}
                  id='GenericDoorkeyImage'
                  style={getStyles(['autoLoginGenericDoorkeyImage'])}
                />
                {t('check_in.digital_key_msg2')}
              </>
            ) : (
              t('check_in.key_from_desk')
            )}
          </Text>
        </View>
      </View>}
      onContinue={handleCloseModal}
      OnRequestClose={handleCloseModal}
      primaryBtnLabel={t('login.okay')}
    />
  );
};

export default AutoLoginSuccessModal;
